<template>
    <div class="city_update">
        <tabs>
            <tab name="Genel">
                <div class="row">
                    <div class="col-md-12">
                        <div class="widget">
                            <div class="form-elements-sec">
                                <div class="widget-title">
                                    <h3>Şehir Ekle</h3>
                                </div>
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="icon">Icon</label>
                                            <input type="file" @change="onIcon" class="form-control custom-input">
                                            <div v-if="display_icon" class="image_content">
                                                <img :src="display_icon" alt="" class="display-img">
                                                <button type="button" class="btn btn-danger trash-btn"
                                                        @click="destroyIcon()"><i class="fa fa-trash"></i></button>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="image">Resim</label>
                                            <input type="file" @change="onImage" class="form-control custom-input">
                                            <div v-if="display_image" class="image_content">
                                                <img :src="display_image" alt="" class="display-img">
                                                <button type="button" class="btn btn-danger trash-btn"
                                                        @click="destroyCover()"><i class="fa fa-trash"></i></button>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="name">Şehir İsmi</label>
                                            <input type="text" class="form-control custom-input" v-model="name">
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="slug">SEF Link</label>
                                            <input type="text" class="form-control custom-input" v-model="slug">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </tab>
            <tab name="Listeleme">
                <div class="row">
                    <div class="col-md-12">
                        <div class="widget">
                            <div class="form-elements-sec">
                                <div class="widget-title">
                                    <h3>Şehir Ekle</h3>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label for="title">Başlık</label>
                                            <input class="form-control custom-input" v-model="title">
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="keywords">Meta Keywords</label>
                                            <textarea class="form-control custom-input" v-model="keywords"
                                                      rows="5"></textarea>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="description">Meta Description</label>
                                            <textarea class="form-control custom-input" v-model="description"
                                                      rows="5"></textarea>
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label for="spot">Spot</label>
                                            <vue-editor :editorToolbar="customToolbar" v-model="spot"
                                                        class="editor"></vue-editor>
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label for="list_seo">Şehir Description</label>
                                            <vue-editor :editorToolbar="customToolbar" v-model="list_seo"
                                                        class="editor"></vue-editor>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </tab>
            <tab name="Şehir Tanıtımı">
                <div class="row">
                    <div class="col-md-12">
                        <div class="widget">
                            <div class="form-elements-sec">
                                <div class="widget-title">
                                    <h3>Şehir Ekle</h3>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label for="detail_title">Başlık</label>
                                            <input class="form-control custom-input" v-model="detail_title">
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="detail_keywords">Meta Keywords</label>
                                            <textarea
                                                    class="form-control custom-input"
                                                    v-model="detail_keywords"
                                                    rows="5"
                                            ></textarea>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="detail_description">Meta Description</label>
                                            <textarea
                                                    class="form-control custom-input"
                                                    v-model="detail_description"
                                                    rows="5"
                                            ></textarea>
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label for="detail_spot">Spot</label>
                                            <vue-editor :editorToolbar="customToolbar" v-model="detail_spot"
                                                        class="editor"></vue-editor>
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label for="content">Şehir Hakkında</label>
                                            <vue-editor :editorToolbar="customToolbar" v-model="content"
                                                        class="editor"></vue-editor>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </tab>
            <tab name="Erkek Öğr. SEO">
                <div class="row">
                    <div class="col-md-12">
                        <div class="widget">
                            <div class="form-elements-sec">
                                <div class="widget-title">
                                    <h3>Şehir Ekle</h3>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label for="male_title">Başlık</label>
                                            <input class="form-control custom-input" v-model="male_title">
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="male_keywords">Meta Keywords</label>
                                            <textarea class="form-control custom-input" v-model="male_keywords"
                                                      rows="5"></textarea>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="male_description">Meta Description</label>
                                            <textarea
                                                    class="form-control custom-input"
                                                    v-model="male_description"
                                                    rows="5"
                                            ></textarea>
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label for="male_spot">Spot</label>
                                            <vue-editor :editorToolbar="customToolbar" v-model="male_spot"
                                                        class="editor"></vue-editor>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </tab>
            <tab name="Kız Öğr. SEO">
                <div class="row">
                    <div class="col-md-12">
                        <div class="widget">
                            <div class="form-elements-sec">
                                <div class="widget-title">
                                    <h3>Şehir Ekle</h3>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label for="female_title">Başlık</label>
                                            <input class="form-control custom-input" v-model="female_title">
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="female_keywords">Meta Keywords</label>
                                            <textarea
                                                    class="form-control custom-input"
                                                    v-model="female_keywords"
                                                    rows="5"
                                            ></textarea>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="female_description">Meta Description</label>
                                            <textarea
                                                    class="form-control custom-input"
                                                    v-model="female_description"
                                                    rows="5"
                                            ></textarea>
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label for="female_spot">Spot</label>
                                            <vue-editor :editorToolbar="customToolbar" v-model="female_spot"
                                                        class="editor"></vue-editor>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </tab>
            <tab name="Resim Galerisi">
                <div class="row">
                    <div class="col-md-12">
                        <div class="widget">
                            <div class="form-elements-sec">
                                <div class="widget-title">
                                    <h3>Şehir Ekle</h3>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label for="gallery">
                                                Resim Galerisi
                                                <small>(Birden fazla seçim yapılabilir)</small>
                                            </label>
                                            <input
                                                    type="file"
                                                    class="form-control custom-input"
                                                    @change="gallery"
                                                    multiple
                                            >
                                        </div>
                                    </div>
                                    <!--  -->
                                    <draggable v-model="images">
                                        <transition-group>
                                            <div class="col-md-4 galleryImage" v-for="image in images" :key="image.id">
                                                <img :src="image.filename" alt class="img-responsive">
                                                <button class="btn btn-danger trash-btn" @click="destroyImage(image)"><i
                                                        class="fa fa-trash"></i></button>
                                            </div>
                                        </transition-group>
                                    </draggable>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </tab>
        </tabs>
        <div class="row">
            <div class="col-md-12">
                <div class="widget text-center">
                    <div class="form-elements-sec">
                        <button class="btn btn-success" @click="create">Kaydet</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {VueEditor} from "vue2-editor";
import draggable from 'vuedraggable'

export default {
    components: {VueEditor, draggable,},
    data() {
        return {
            isReady: false,
            customToolbar: [
                ['bold', 'italic', 'underline'],
                [{'list': 'ordered'}, {'list': 'bullet'}]
            ],
            id: this.$route.params.id,
            api: "cities/",
            image: "",
            display_image: '',
            display_icon: '',
            icon: "",
            name: "",
            slug: "",
            title: "",
            keywords: "",
            description: "",
            spot: "",
            content: "",
            list_seo: "",
            detail_title: "",
            detail_keywords: "",
            detail_description: "",
            detail_spot: "",
            male_title: "",
            male_keywords: "",
            male_description: "",
            male_spot: "",
            female_title: "",
            female_keywords: "",
            female_description: "",
            female_spot: "",
            images: []
        };
    },
    created() {
        this.getData();
    },
    methods: {
        onIcon() {
            this.icon = event.target.files[0];
            // console.log(this.icon);
        },
        onImage() {
            this.image = event.target.files[0];
            // console.log(this.image);
        },
        gallery(e) {
            let selectedFlies = e.target.files;
            if (!selectedFlies.length) {
                return false;
            }
            for (let i = 0; i < selectedFlies.length; i++) {
                this.images.push(selectedFlies[i]);
            }
            // console.log(this.images);
        },
        create() {
            let data = {
                image: this.image || '',
                icon: this.icon || '',
                name: this.name || '',
                slug: this.slug || '',
                title: this.title || '',
                keywords: this.keywords || '',
                description: this.description || '',
                spot: this.spot || '',
                list_seo: this.list_seo || '',
                content: this.content || '',
                detail_title: this.detail_title || '',
                detail_keywords: this.detail_keywords || '',
                detail_description: this.detail_description || '',
                detail_spot: this.detail_spot || '',
                male_title: this.male_title || '',
                male_keywords: this.male_keywords || '',
                male_description: this.male_description || '',
                male_spot: this.male_spot || '',
                female_title: this.female_title || '',
                female_keywords: this.female_keywords || '',
                female_description: this.female_description || '',
                female_spot: this.female_spot || '',
            };
            const formData = new FormData();
            if (this.image) {
                formData.append("image", this.image);
            }
            if (this.icon) {
                formData.append("icon", this.icon);
            }
            if (this.images.length > 0) {
                for (let i = 0; i < this.images.length; i++) {
                    formData.append("images[]", this.images[i]);
                }
            }
            formData.append("_method", "POST");
            Object.keys(data).map(e => {
                formData.append(e, data[e]);
            });
            this.$Progress.start();
            this.axios.post(this.api, formData).then(response => {
                // console.log(response);
                this.$Progress.finish();
                if (response.status == 201) {
                    this.$router.push({
                        name: "cities.update",
                        params: {id: response.data.id}
                    });
                }
            }).catch(error => {
                this.$Progress.finish();
                this.loading = false;
                this.$swal.fire({
                    position: 'top-end',
                    type: 'error',
                    title: 'İşlem başarısız!',
                    showConfirmButton: false,
                    timer: 1500
                });
                if (error.response.status == 422) {
                    this.validationErrors = error.response.data.errors;
                } else if (error.response.status == 500) {
                    this.validationErrors = {message: ['Bilinmeyen bir hata oluştu. Lütfen servis sağlayıcınıza başvurun veya daha sonra tekrar deneyiniz.!']};
                }
            });
        },
        destroyImage(image) {
            var index = this.images.indexOf(image);
            this.images.splice(index, 1);
        },
        destroyCover() {
            this.display_image = '';
        },
        destroyIcon() {
            this.display_icon = '';
        }
    }
};
</script>
<style scoped>
.galleryImage {
    margin-bottom: 10px;
    position: relative;
}

.galleryImage img {
    border-radius: 6px;
    opacity: 0.7;
}

.galleryImage img:hover {
    transition: 0.5s;
    opacity: 1;
}

.display-img {
    width: 250px;
}

.trash-btn {
    position: absolute;
    top: 15px;
    right: 25px;
}

.image_content {
    position: relative;
}
</style>
